<script>
import { fly } from 'svelte/transition';
export let width;
export let image;

let linkto = 'https://covecreekproductions.com/'
image = image || './images/cc_white.png';
width = width || 150;

function openUrl(){
    let win = window.open(linkto, '_blank');
    win.focus();
}
</script>

<style>
    div {
        position: absolute;
        right: 20px;
        bottom: 20px;
        z-index: 999;
        cursor:pointer;
    }
    
    img {
        height: auto;
        opacity: 0.60;
    }

    img:hover {
        opacity: 1;
    }

    @media only screen and (max-width: 600px) {
        div {
            display: none;
        }
    }
</style>

<div on:click={openUrl}  transition:fly={{y: 300, duration: 500 }}>
    <img src={image} width={width} alt="Made by CoveCreek Productions"/>
</div>
